<ng-container *ngIf='!isMobileView; else mobileView'>
  <div *ngIf='sessionData' class='CampaignsListing container-fluid'>
    <div class='CampaignsListing-block'>
      <div class='CampaignsListing-block-header d-flex flex-row'>
        <h4 class='title__page'>Active Campaigns</h4>
        <app-svg-renderer
          (click)='onInfoImageClick()'
          [svg]="'Yellow Plane'"
          class='ms-1 mt-1 cursor-pointer'></app-svg-renderer>
      </div>
      <div class='CampaignsListing-block-body'>
        <div class='row'>
          <div
            class='CampaignsListing-block-body-nsd col col-12 col-md-2 offset-0 offset-md-5'>
            <p>Next Service Date</p>
          </div>
        </div>
        <div
          *ngFor='let item of activeCampaigns'
          class='CampaignsListing-block-body-list-item row'>
          <div
            class='col col-12 col-md-5 d-flex flex-row justify-content-between align-items-center'>
            <h5>
              {{ item.campaign_name }}
              <span *ngIf='item.campaign_type'
              >({{ getCampaignType(item) }})</span
              >
            </h5>
          </div>
          <div
            class='col col-12 col-md-2 d-flex flex-row justify-content-between align-items-center'>
            <div
              class='CampaignsListing-block-body-nsd'>
              <a (click)='openNextServiceDateDialog(item)'>{{
                  getScheduledDate(item)
                }}</a>
            </div>
          </div>
          <div
            class='col col-12 col-md-5 d-flex flex-row justify-content-between align-items-center'>
          <span *ngIf='!sessionData.permissions.can_update_campaign'
          >Representative: {{ item.account_email }}</span
          >
            <app-button
              *ngIf='sessionData.permissions.can_update_campaign && sessionData.user_type !== userTypes.MANAGER'
              [color]='editCampaignButton.color'
              [route]='getEditButtonRoute(item)'
              [size]='editCampaignButton.size'
              [style]='editCampaignButton.style'
              [text]='editCampaignButton.text'
              class='CampaignsListing-block-body-list-item-button'></app-button>
            <app-button
              *ngIf='sessionData.permissions.can_update_campaign && sessionData.user_type !== userTypes.MANAGER'
              [Click]='
              pendingCampaignButton.onClick.bind(this, item)
            '
              [color]='pendingCampaignButton.color'
              [size]='pendingCampaignButton.size'
              [text]='pendingCampaignButton.text'
              [observeApi]="true"
              [locked]="true"
              class='CampaignsListing-block-body-list-item-button'></app-button>
          </div>
        </div>

        <div class='CampaignsListing-block-body-paginator'>
          <app-paginator
            #paginatorActive
            [currentPage]='
            activeCampaignsPagination.current_page
          '
            [length]='activeCampaignsPagination.total_pages_count'
            [pageSizeOptions]='[10, 15, 20, 50, 100]'
            [pageSize]='activeCampaignsPagination.page_size'
            [showFirstLastButtons]='true'
            [showItemsPerPage]='false'
            [showPrevNextButtons]='true'
            [totalCount]='activeCampaignsPagination.total_count'></app-paginator>
        </div>
      </div>
    </div>
    <div class='CampaignsListing-block'>
      <div class='CampaignsListing-block-header'>
        <h4>Pending Campaigns</h4>
      </div>
      <div class='CampaignsListing-block-body'>
        <div
          *ngFor='let item of pendingCampaigns'
          class='CampaignsListing-block-body-list-item row'>
          <div
            class='col col-12 col-md-5 d-flex flex-row justify-content-between align-items-center'>
            <h5>
              {{ item.campaign_name }}
              <span *ngIf='item.campaign_type'
              >({{ getCampaignType(item) }})</span
              >
            </h5>
          </div>
          <div
            class='col col-12 col-md-5 offset-0 offset-md-2 d-flex flex-row justify-content-between align-items-center'>
          <span *ngIf='!sessionData.permissions.can_update_campaign'
          >Representative: {{ item.account_email }}</span
          >
            <span
              *ngIf='
              item.campaign_published_state &&
              sessionData.user_type !== userTypes.PARTNER &&
              sessionData.user_type !== userTypes.MANAGER
            '
              [popover]="isActivateButtonDisabled(item) ? 'This campaign is of type \'click2recruit\'. Your click2recruit feature is currently disabled. If you want to activate this campaign, please contact the customer support.' : null"
              [popoverPlacement]="'left'"
              [popoverOnHover]="true"
              [popoverDisabled]="!isActivateButtonDisabled(item)"
              style="display: inline-block;">
              <app-button
                [Click]='
                activateCampaignButton.onClick.bind(this, item)
              '
                [color]='activateCampaignButton.color'
                [size]='activateCampaignButton.size'
                [text]='activateCampaignButton.text'
                [locked]="true"
                [disabled]='isActivateButtonDisabled(item)'
                class='CampaignsListing-block-body-list-item-button'></app-button>
            </span>
            <span
              *ngIf='
              !item.campaign_published_state &&
              sessionData.user_type !== userTypes.PARTNER &&
              sessionData.user_type !== userTypes.MANAGER
            '
              [popover]="isActivateButtonDisabled(item) ? 'This campaign is of type \'click2recruit\'. Your click2recruit feature is currently disabled. If you want to activate this campaign, please contact the customer support.' : null"
              [popoverPlacement]="'left'"
              [popoverOnHover]="true"
              [popoverDisabled]="!isActivateButtonDisabled(item)"
              style="display: inline-block;">
              <app-button
                [color]='completeCampaignButton.color'
                [queryParams]='getCompleteButtonQueryParams()'
                [routerLink]='isActivateButtonDisabled(item) ? null : getCompleteButtonRouter(item)'
                [size]='completeCampaignButton.size'
                [text]='completeCampaignButton.text'
                [disabled]='isActivateButtonDisabled(item)'
                class='CampaignsListing-block-body-list-item-button'></app-button>
            </span>
            <app-button
              *ngIf='
                sessionData.user_type !== userTypes.PARTNER &&
              sessionData.user_type !== userTypes.MANAGER
              '
              [Click]='
              deleteCampaignButton.onClick.bind(this, item)
            '
              [color]='deleteCampaignButton.color'
              [size]='deleteCampaignButton.size'
              [text]='deleteCampaignButton.text'
              [locked]="true"
              [observeApi]="true"
              class='CampaignsListing-block-body-list-item-button'></app-button>
          </div>
        </div>

        <div class='CampaignsListing-block-body-paginator'>
          <app-paginator
            #paginatorPending
            [currentPage]='
            pendingCampaignsPagination.current_page
          '
            [length]='pendingCampaignsPagination.total_pages_count'
            [pageSizeOptions]='[10, 20, 50, 100]'
            [pageSize]='pendingCampaignsPagination.page_size'
            [showFirstLastButtons]='true'
            [showItemsPerPage]='false'
            [showPrevNextButtons]='true'
            [totalCount]='pendingCampaignsPagination.total_count'></app-paginator>
        </div>
      </div>
    </div>
    <div class='CampaignsListing-block'>
      <div class='CampaignsListing-block-header'>
        <h4>Deleted Campaigns</h4>
      </div>
      <div class='CampaignsListing-block-body'>
        <div
          *ngFor='let item of deletedCampaigns'
          class='CampaignsListing-block-body-list-item row'>
          <div
            class='col col-12 col-md-5 d-flex flex-row justify-content-between align-items-center'>
            <h5>
              {{ item.campaign_name }}
              <span *ngIf='item.campaign_type'
              >({{ getCampaignType(item) }})</span
              >
            </h5>
          </div>
          <div
            class='col col-12 col-md-5 offset-0 offset-md-2 d-flex flex-row justify-content-between align-items-center'>
          <span *ngIf='!sessionData.permissions.can_update_campaign'
          >Representative: {{ item.account_email }}</span
          >
            <span
              *ngIf='
                sessionData.user_type !== userTypes.PARTNER &&
                sessionData.user_type !== userTypes.MANAGER
              '
              [popover]="isActivateButtonDisabled(item) ? 'This campaign is of type \'click2recruit\'. Your click2recruit feature is currently disabled. If you want to activate this campaign, please contact the customer support.' : null"
              [popoverPlacement]="'left'"
              [popoverOnHover]="true"
              [popoverDisabled]="!isActivateButtonDisabled(item)"
              style="display: inline-block;">
              <app-button
                [Click]='
                restoreCampaignButton.onClick.bind(this, item)
              '
                [color]='restoreCampaignButton.color'
                [size]='restoreCampaignButton.size'
                [text]='restoreCampaignButton.text'
                [locked]="true"
                [disabled]='isActivateButtonDisabled(item)'
                class='CampaignsListing-block-body-list-item-button'></app-button>
            </span>
          </div>
        </div>
        <div class='CampaignsListing-block-body-paginator'>
          <app-paginator
            #paginatorDeleted
            [currentPage]='
            deletedCampaignsPagination.current_page
          '
            [length]='deletedCampaignsPagination.total_pages_count'
            [pageSizeOptions]='[10, 20, 50, 100]'
            [pageSize]='deletedCampaignsPagination.page_size'
            [showFirstLastButtons]='true'
            [showItemsPerPage]='false'
            [showPrevNextButtons]='true'
            [totalCount]='deletedCampaignsPagination.total_count'></app-paginator>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #mobileView>
  <div class='CampaignsMobileView'>
    <div class='CampaignsMobileView--header d-flex justify-content-center mb-4'>
      <h4>Campaigns</h4>
    </div>
    <div class='CampaignsMobileView--body'>
      <mat-tab-group #tabGroup mat-align-tabs='center'>
        <mat-tab label='Active'>
          <div
            *ngFor='let item of activeCampaigns'
            class='CampaignsMobileView--body--row'>
            <div class='CampaignsMobileView--body--row--item'>
              <span>{{ item.campaign_name }}</span>
              <span *ngIf='item.campaign_type' class='text-muted'
              >({{ getCampaignType(item) }})</span
              >
            </div>
            <div class='CampaignsMobileView--body--row--item service'>
              <a (click)='openNextServiceDateDialog(item)' class='CampaignsMobileView--body--row--item--service'>{{
                  getScheduledDate(item)
                }}</a>
              <span *ngIf='!sessionData.permissions.can_update_campaign'
              >Representative: {{ item.account_email }}</span
              >
            </div>
            <div class='CampaignsMobileView--body--row--item'>
              <app-menu-button [properties]='activeCampaignMenuButtonItems'
                               [target]='item'></app-menu-button>
            </div>
          </div>
        </mat-tab>
        <mat-tab label='Pending'>
          <div
            *ngFor='let item of pendingCampaigns'
            class='CampaignsMobileView--body--row'>
            <div class='CampaignsMobileView--body--row--item'>
              <span>{{ item.campaign_name }}</span>
              <span *ngIf='item.campaign_type' class='text-muted'
              >({{ getCampaignType(item) }})</span
              >
            </div>
            <div class='CampaignsMobileView--body--row--item service'>
              <a (click)='openNextServiceDateDialog(item)' class='CampaignsMobileView--body--row--item--service'>{{
                  getScheduledDate(item)
                }}</a>
              <span *ngIf='!sessionData.permissions.can_update_campaign'
              >Representative: {{ item.account_email }}</span
              >
            </div>
            <div class='CampaignsMobileView--body--row--item'>
              <app-menu-button [properties]='pendingCampaignsMenuButtonProperties' [target]='item'></app-menu-button>
            </div>
          </div>
        </mat-tab>
        <mat-tab label='Deleted'>
          <div
            *ngFor='let item of deletedCampaigns'
            class='CampaignsMobileView--body--row'>
            <div class='CampaignsMobileView--body--row--item'>
              <span>{{ item.campaign_name }}</span>
              <span *ngIf='item.campaign_type' class='text-muted'
              >({{ getCampaignType(item) }})</span
              >
            </div>
            <div class='CampaignsMobileView--body--row--item service'>
              <a (click)='openNextServiceDateDialog(item)' class='CampaignsMobileView--body--row--item--service'>{{
                  getScheduledDate(item)
                }}</a>
              <span *ngIf='!sessionData.permissions.can_update_campaign'
              >Representative: {{ item.account_email }}</span
              >
            </div>
            <div class='CampaignsMobileView--body--row--item'>
              <app-menu-button [properties]='restoreCampaignsButtonProperties' [target]='item'></app-menu-button>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div #lazyLoadingBorder class='Table__lazy-loading-border'></div>
  </div>
</ng-template>
